let isRegistered = false;
export async function registerStaticModules(registerFunctions, runtime, { context } = {}) {
    if (isRegistered) {
        throw new Error('[shell] The "registerRemoteModules" function can only be called once');
    }
    runtime.logger.information(`[shell] Found ${registerFunctions.length} static module${registerFunctions.length > 1 ? 's' : ''} to register`);
    await Promise.allSettled(registerFunctions.map(async (x, index) => {
        runtime.logger.information(`[shell] ${index + 1}/${registerFunctions.length} Registering static module`);
        await x(runtime, context);
        runtime.logger.information(`[shell] ${index + 1}/${registerFunctions.length} Registration completed`);
    }));
    isRegistered = true;
}
